<template>
  <v-container fluid>
    <v-snackbar v-model="snackbar" :timeout="timeout" color="warning">
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">Close</v-btn>
      </template>
    </v-snackbar>
    <v-row class="d-flex justify-space-between align-center" style="padding: 0 !important;">
      <v-col cols="auto" style="padding: 10px !important;">
        <h5 style="font-weight: bold; color: white; font-size: 20px "> Geomap Agent </h5>
      </v-col>
      <v-col cols="auto"  style="padding: 10px !important;" v-if="canCreateEudr">
        <v-btn v-if="userId" class="custom-btn" @click="createAgentPopDialog ">CREATE AGENT</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" style="padding: 10px !important; margin-top: 5px; ">
        <div class="elevation-4" :style="{ backgroundColor: '#FFFFFF'}" style="padding: 0 !important;">
          <v-card-text style="padding-bottom: 0 !important;">
            <v-row class="d-flex justify-space-between align-center">
              <v-col cols="auto">
                <h4 style="font-weight: bold; font-size: 16px"> Geomap Agent Overview </h4>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto" >
                <v-text-field label="Search" v-model="search" :style="{ width: '300px' }"></v-text-field>
              </v-col>
            </v-row>
            <div class="table-responsive">
              <table class="table">
                <thead class="thead">
                <tr>
                  <th scope="col">First Name</th>
<!--                  <th scope="col">Second Name</th>-->
                  <th scope="col">Last Name</th>
                  <th scope="col">Id Number</th>
                  <th scope="col">Email</th>
                  <th scope="col">Phone</th>
                  <th scope="col">Status</th>
                  <th scope="col">Date</th>
                  <th scope="col"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in filteredList" v-bind:key="item.id">
                  <td>{{ item.fname }}</td>
<!--                  <td>{{ item.sname }}</td>-->
                  <td>{{ item.lname }}</td>
                  <td>{{ item.idNum }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.status.statusName }}</td>
                  <td>{{ formatDate(item.created)}}</td>
                  <td class="actions">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn color="primary" v-on="on" text icon class="actions">
                          <v-icon class="secondary--text"> more_horiz</v-icon>
                        </v-btn>
                      </template>
                      <v-list>

                        <v-list-item v-if="canCreateEudr || canApproveEudr" @click="showGrowers(item.id)">
                          <v-list-item-title > View Farmers</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="canCreateEudr" @click="editGrower(item.id)">
                          <v-list-item-title>Edit</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="canApproveEudr" @click="confirmApproveReject(item.id, 1)">
                          <v-list-item-title>Approve</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="canApproveEudr" @click="confirmApproveReject(item.id, 0)">
                          <v-list-item-title>Reject</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </v-card-text>
          <v-card-actions>
            <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
            <v-spacer></v-spacer>
            <v-pagination
              v-model="page"
              :length="numberOfLinks"
              :total-visible="3"
              color="secondary"
                class="accent--text logoutbtn"
            ></v-pagination>
          </v-card-actions>
        </div>
      </v-col>
      <v-dialog v-model="createAgentDialog" max-width="800px">
        <v-card>
          <v-card-title>
            <span class="headline">Create Agent</span>
          </v-card-title>

          <v-card-text>
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="firstNameValue"
                    label="First Name"
                    placeholder="Type here"
                    clearable
                    :error="fNameError"
                    :error-messages="fNameError ? 'Enter a valid first name' : ''"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="lastNameValue"
                    label="Last Name"
                    placeholder="Type here"
                    clearable
                    :error="lNameError"
                    :error-messages="lNameError ? 'Enter a valid last name' : ''"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="idNumberValue"
                    label="ID Number"
                    type="number"
                    placeholder="Type here"
                    clearable
                    :error="idNumError"
                    :error-messages="idNumError ? 'Enter a valid id number' : ''"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="phoneValue"
                    label="Phone Number"
                    type="number"
                    hint="Phone number format is 0xxxxxxxxx"
                    placeholder="Type here"
                    :error="phoneError"
                    :error-messages="phoneError ? 'Enter a valid phone number' : ''"
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="emailValue"
                    label="Email Address"
                    placeholder="Type here"
                    clearable
                    :error="emailError"
                    :error-messages="emailError ? 'Enter a valid email' : ''"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <v-autocomplete
                    v-model="growersSelected"
                    :items="growers"
                    hint="Select farmers"
                    label="Select"
                    multiple
                    persistent-hint
                    item-text="value"
                    item-value="key"
                    :error="growersError"
                    :error-messages="growersError ? 'Enter a valid grower' : ''"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-btn color="secondary"
                class="accent--text logoutbtn" @click="createAgentDialog = false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="custom-btn" style="font-size: 15px" @click="createAgent" :loading="loading">Create</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editAgentDialog" max-width="800px">
        <v-card>
          <v-card-title>
            <span class="headline">Create Agent</span>
          </v-card-title>

          <v-card-text>
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="firstNameValueEdit"
                    label="First Name"
                    placeholder="Type here"
                    clearable
                    :error="fNameErrorEdit"
                    :error-messages="fNameErrorEdit ? 'Enter a valid first name' : ''"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="lastNameValueEdit"
                    label="Last Name"
                    placeholder="Type here"
                    clearable
                    :error="lNameErrorEdit"
                    :error-messages="lNameErrorEdit ? 'Enter a valid last name' : ''"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="idNumberValueEdit"
                    label="ID Number"
                    type="number"
                    placeholder="Type here"
                    clearable
                    :error="idNumErrorEdit"
                    :error-messages="idNumErrorEdit ? 'Enter a valid id number' : ''"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="phoneValueEdit"
                    label="Phone Number"
                    type="number"
                    hint="Phone number format is 0xxxxxxxxx"
                    placeholder="Type here"
                    clearable
                    :error="phoneErrorEdit"
                    :error-messages="phoneErrorEdit ? 'Enter a valid phone number' : ''"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="emailValueEdit"
                    label="Email Address"
                    placeholder="Type here"
                    clearable
                    :error="emailErrorEdit"
                    :error-messages="emailErrorEdit ? 'Enter a valid email' : ''"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <v-autocomplete
                    v-model="growersSelectedEdit"
                    :items="growers"
                    hint="Select growers"
                    label="Select"
                    multiple
                    persistent-hint
                    item-text="value"
                    item-value="key"
                    :error="growersErrorEdit"
                    :error-messages="growersErrorEdit ? 'Enter a valid grower' : ''"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-btn color="secondary"
                class="accent--text logoutbtn" @click="editAgentDialog = false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="#7BC243" style="border: 1px solid #7BC243" @click="editAgent" :loading="loadingEdit">Edit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="approveRejectDialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Approve/Reject</span>
          </v-card-title>

          <v-card-actions>
            <v-btn color="secondary"
                class="accent--text logoutbtn"  @click="approveRejectDialog = false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="!approveRejectStatus" color="primary" style="border: 1px solid firebrick" @click="approveRejectAgent(0)" :loading="loading">Reject</v-btn>
            <v-btn v-if="approveRejectStatus" color="#7BC243" style="border: 1px solid #7BC243" @click="approveRejectAgent(1)" :loading="loading">Approve</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="growersDialog" max-width="1000px">
        <v-card>
          <v-card-title >
            <span class="headline">Farmers</span>
          </v-card-title>

          <v-card-text>
            <v-col cols="12" style="padding: 0 !important; margin-top: 15px">
              <div :style="{ backgroundColor: '#FFFFFF'}" style="padding: 0 !important;">
                <v-card-text style="padding-bottom: 0 !important;">
                  <v-data-table
                    :headers="headers"
                    :items="filteredList2"
                    :items-per-page="4"
                    :search="search"
                    class="elevation-3"
                    header-class="brown-header"
                  >
                  </v-data-table>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="primary"  @click="growersDialog = false">Cancel</v-btn>
                </v-card-actions>
              </div>
            </v-col>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import { convertRulesToOptions } from 'devextreme/core/options/utils'
import { mapState } from 'vuex'
import organizationusers from '@/components/views/organization/organizationusers.vue'
export default {
	name: 'geomapagent',
	data: function () {
		return {
			exampleRules: [
				v => !!v || 'This field is required'
				// v => ( v && v >= 5 ) || "Loan should be above £5000",
				// v => ( v && v <= 10 ) || "Max should not be above £50,000",
			],
			phoneRules: [
				(v) => !!v || 'Phone number is required',
				(v) => /^[0-9]{10}$/.test(v) || 'Enter a valid 10-digit phone number'
			],
			emailRules: [
				(v) => !!v || 'Email is required',
				(v) => /\S+@\S+\.\S+/.test(v) || 'Enter a valid email address'
			],
      headers: [
        { text: 'Name', value: 'fullName' },
        { text: 'Member No.', value: 'memberNumber' },
        { text: 'C-One', value: 'coordinateOne' },
        { text: 'C-Two', value: 'coordinateTwo' },
        { text: 'C-Three', value: 'coordinateThree' },
        { text: 'C-Four', value: 'coordinateFour' }
      ],
			growersSelected: [],
			growersSelectedEdit: [],
			growers: [],
			originalGrowersData: {},
			previewItems: [],
			valid: true,
			message: '',
			timeout: 2000,
			snackbar: false,
			snackbarColor: '',
			file: '',
			files: [],
			totalFiles: 0,
			pagination: {
				sortBy: 'id',
				descending: true
			},
			loading: false,
			loadingEdit: false,
			loadingApprove: false,
			search: '',
			expand: false,
			permissions: [],
			timerContent: true,
			previewLoading: false,
			approveloading: false,
			declineloading: false,
			paginatedFiles: [],
			firstNameValue: '',
			firstNameValueEdit: '',
			secondNameValue: '',
			secondNameValueEdit: '',
			lastNameValue: '',
			lastNameValueEdit: '',
			idNumberValue: '',
			idNumberValueEdit: '',
			phoneValue: '',
			phoneValueEdit: '',
			emailValue: '',
			emailValueEdit: '',
			numberOfLinks: 0,
			numberOfItemsPerPage: window.innerHeight <= 600 ? 6 : window.innerHeight > 600 && window.innerHeight <= 1000 ? 14 : 20,
			page: 1,
			currentPage: 0,
			confirmDialog: false,
			createAgentDialog: false,
			fNameError: false,
			sNameError: false,
			lNameError: false,
			idNumError: false,
			phoneError: false,
			emailError: false,
			growersError: false,
			fNameErrorEdit: false,
			sNameErrorEdit: false,
			lNameErrorEdit: false,
			idNumErrorEdit: false,
			phoneErrorEdit: false,
			emailErrorEdit: false,
			growersErrorEdit: false,
			editAgentDialog: false,
			approveRejectDialog: false,
			growersDialog: false,
			textValue1: '',
			textValue2: '',
			confirmDeleteDialog: false,
			confirmFile: {},
			confirmMessage: '',
			action: '',
			uploadFileDialog: false,
			remainingTime: 0, // Total time in days
			interval: null,
			targetDate: '',
			days: 0,
			hours: 0,
			minutes: 0,
			seconds: 0,
			saleNo: '',
			saleDate: '',
			isUploadDisabled: false,
			termsDialog: false,
			showProgressBar: false,
			editId: 0,
			approveRejectStatus: false,
			filteredList2: [],
			organisationType: ''
		}
	},
	mounted () {
		console.log(window.innerHeight)
		this.getInitData(this.currentPage)
		this.permissions = store.state.user.roleId.permissions
		this.startCountdown()
		this.getAllGrowers()
		// this.getUpcomingDate()
	},
	beforeDestroy () {
		clearInterval(this.interval)
	},
	watch: {
		files () {
			this.paginatedFiles = this.files

			// this.paginatedFiles = this.paginationMethod(this.files, 1, this.numberOfItemsPerPage)
			// this.numberOfLinks = Math.ceil(this.files.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			// this.paginatedFiles = this.paginationMethod(this.files, val, this.numberOfItemsPerPage)
			this.paginatedFiles = this.getInitData(val - 1)
		}
	},
	computed: {
		...mapState({ user: (state) => state.user }),
		canUploadCatalogue: function () {
			return this.hasPerm('CAN_UPLOAD_CATALOGUE')
		},
		canCreateEudr: function () {
			return this.hasPerm('CAN_CREATE_EUDR')
		},
		canApproveEudr: function () {
			return this.hasPerm('CAN_APPROVE_EUDR')
		},
		canUpdateCharge: function () {
			return this.hasPerm('CAN_UPDATE_CHARGE')
		},
		canApproveCatalogue: function () {
			return this.hasPerm('CAN_APPROVE_CATALOGUE')
		},
		canUploadCleanCoffee: function () {
			return this.hasPerm('CAN_UPLOAD_PARCHMENT')
		},
		userId: function () {
			if (this.user) {
				console.log('user - ', this.user)
				console.log('user2 - ', this.user.organisation.id)
				this.organisationType = this.user.organisation.organisationType.name
				return 1
			}
			return 0
		},
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.files.filter(file => {
					console.log('file = ', file)
					console.log('filetotalBags = ', file.fname)
					const searchTerm = this.search.toLowerCase()
					var dateCreated = new Date(file.created)
					return (
						(file.fname.toLowerCase().includes(searchTerm)) ||
            // file.sname.toString().includes(searchTerm) ||
            file.lname.toString().includes(searchTerm) ||
            file.email.toString().includes(searchTerm) ||
            file.idNum.toString().includes(searchTerm) ||
            file.phone.toString().includes(searchTerm) ||
            file.status.statusName.toLowerCase().includes(searchTerm) ||
            file.createdBy.toLowerCase().includes(searchTerm) ||
            dateCreated.toDateString().toLowerCase().includes(searchTerm)
					)
				})
				// return this.files.filter(file => { return file.fileName.toLowerCase().includes(this.search.toLowerCase()) })
			}
		}
	},
	methods: {
		formatDate (dateString) {
			const date = new Date(dateString)
			return date.toLocaleDateString('en-US', {
				year: 'numeric',
				month: 'long', // e.g., "September"
				day: 'numeric' // e.g., "15"
			})
		},
		startCountdown () {
			this.interval = setInterval(this.updateCountdown, 1000)
		},
		canBeApproved (item) {
			return (item.status.id === 3 || item.status.id === 0) && this.hasPerm('CAN_APPROVE_CATALOGUE')
		},
		auctionFile (item) {
			return item.status.statusName === 'APPROVED'
		},
		canBeDeclined (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_CATALOGUE')
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		handleFileUpload () {
			this.file = this.$refs.file.files[0]
		},
		getAllGrowers () {
			this.approveloading = true
			const url = config.serverURI + '/udr/farmers'
			axios.get(url, { timeout: 70000 })
				.then(response => {
					// this.growers = response.data
					console.log('helloRRR')
					console.log('helloRRR - ', response)
					this.growers.length = 0
					response.data.forEach(x => {
						const val = x.fullName + ' - ' + x.memberNumber
						// const val = x.organisationCode + ' (' + x.organisationName + ')'

						const obj = { key: x.farmerId, value: val }
						this.growers.push(obj)
					})
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
					this.approveloading = false
				})
		},
		createAgent () {
			console.log('growersSelected - ', this.growersSelected)
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
			const phoneRegex = /^\+?[0-9]{10,15}$/
			const idNumRegex = /^\+?[0-9]{10,11}$/
			const onlyCharactersRegex = /^[a-zA-Z]*$/
			this.fNameError = false
			// this.sNameError = false
			this.lNameError = false
			this.idNumError = false
			this.phoneError = false
			this.emailError = false
			this.growersError = false

			console.log(emailRegex.test(this.emailValue))
			if (this.firstNameValue === '' || !onlyCharactersRegex.test(this.firstNameValue)) {
				this.fNameError = true
				return
			}
			/* if (this.secondNameValue === '') {
				this.secondNameValue = 'Nil'
			} */
			if (this.lastNameValue === '' || !onlyCharactersRegex.test(this.lastNameValue)) {
				this.lNameError = true
				return
			}
			if (this.idNumberValue === '' || this.idNumberValue.length > 10) {
				this.idNumError = true
				return
			}
			if (this.phoneValue === '' || !phoneRegex.test(this.phoneValue)
        || !this.phoneValue.startsWith('0') || this.phoneValue.length !== 10) {
				console.log('phone error')
				this.phoneError = true
				return
			}

			if (this.emailValue === '' || !emailRegex.test(this.emailValue)) {
				console.log('email error')
				this.emailError = true
				return
			}

			if (this.growersSelected.length === 0) {
				this.growersError = true
				return
			}

			this.loading = true
			const url = config.serverURI + '/udr/create'
			// console.log('calling ' + url)

			// return


			const document = {
				firstName: this.firstNameValue,
				// secondName: this.secondNameValue,
				lastName: this.lastNameValue,
				idNumber: this.idNumberValue,
				email: this.emailValue,
				phone: this.phoneValue = '254' + this.phoneValue.slice(1),
				growers: this.growersSelected
			}
			axios.post(url, document)
				.then(response => {
					this.loading = false
					if (response.data.error !== false) {
						this.message = 'Successful created agent'
						this.snackbar = true
						this.snackbarColor = 'error'
						this.createAgentDialog = false
						this.getInitData(this.currentPage)
						return
					}
					// this.getInitData(this.currentPage)
					this.message = 'Something went wrong, please try again'
					this.snackbar = true
					this.snackbarColor = 'primary'
				})
				.catch(error => {
					console.log('error', error)
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'warning'
					this.loading = false
				})
			this.confirmDialog = false
		},
		editAgent () {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
			const phoneRegex = /^\+?[0-9]{10,15}$/
			const idNumRegex = /^\+?[0-9]{10,11}$/
			this.fNameErrorEdit = false
			// this.sNameErrorEdit = false
			this.lNameErrorEdit = false
			this.idNumErrorEdit = false
			this.phoneErrorEdit = false
			this.emailErrorEdit = false
			this.growersErrorEdit = false

			if (this.firstNameValueEdit === '') {
				this.fNameErrorEdit = true
				return
			}
			// if (this.secondNameValueEdit === ''){
			//   this.sNameErrorEdit = true
			//   return
			// }
			if (this.lastNameValueEdit === '') {
				this.lNameErrorEdit = true
				return
			}
			if (this.idNumberValueEdit === '' || this.idNumberValueEdit.length > 10) {
				// if (this.idNumberValueEdit === '' || !idNumRegex.test(this.idNumberValueEdit)){
				this.idNumErrorEdit = true
				return
			}
			if (this.phoneValueEdit === '' || !phoneRegex.test(this.phoneValueEdit)) {
				console.log('phone error')
				this.phoneErrorEdit = true
				return
			}

			if (this.emailValueEdit === '' || !emailRegex.test(this.emailValueEdit)) {
				console.log('email error')
				this.emailErrorEdit = true
				return
			}

			if (this.growersSelectedEdit.length === 0) {
				this.growersErrorEdit = true
				return
			}

			this.loadingEdit = true
			const url = config.serverURI + '/udr/edit?id=' + this.editId
			// console.log('calling ' + url)
			const growers = this.growersSelectedEdit
			// const growers = Object.values(this.growersSelectedEdit)
			// console.log('---->> ',this.growersSelectedEdit)
			// this.growersSelectedEdit.forEach(x => {
			//   growers.push(x.key)
			// })
			console.log('---->>>00> ', this.growersSelectedEdit)
			console.log('---->>>> ', growers)
			const allGrowers = []
			growers.forEach(x => {
				console.log('----==-- ', x)
				console.log('----==-->> ', x.key)
				if (x.key !== undefined) {
					allGrowers.push(x.key)
				} else {
					allGrowers.push(x)
				}
				// console.log('---- ', x.value)
			})
			console.log('---->>>>23 ', allGrowers)

			// return
			const document = {
				firstName: this.firstNameValueEdit,
				// secondName: this.secondNameValueEdit,
				lastName: this.lastNameValueEdit,
				idNumber: this.idNumberValueEdit,
				email: this.emailValueEdit,
				phone: this.phoneValueEdit,
				growers: allGrowers
			}
			console.log('editId - ', this.editId)
			console.log('document - ', document)
			axios.post(url, document)
				.then(response => {
					this.loadingEdit = false
					if (response.data.error !== false) {
						this.message = 'Successfully edited agent'
						this.snackbar = true
						this.snackbarColor = 'error'
						this.editAgentDialog = false
						this.getInitData(this.currentPage)
						return
					}
					// this.getInitData(this.currentPage)
					this.message = 'Something went wrong, please try again'
					this.snackbar = true
					this.snackbarColor = 'primary'
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
					this.loadingEdit = false
				})
			this.confirmDialog = false
		},
		approveRejectAgent (status) {
			this.loading = true
			const url = config.serverURI + '/udr/approve?id=' + this.editId + '&status=' + status
			// console.log('calling ' + url)
			const growers = []
			this.growersSelectedEdit.forEach(x => {
				growers.push(x.key)
			})
			const document = {
				firstName: this.firstNameValueEdit,
				secondName: this.secondNameValueEdit,
				lastName: this.lastNameValueEdit,
				idNumber: this.idNumberValueEdit,
				email: this.emailValueEdit,
				phone: this.phoneValueEdit,
				growers: growers
			}
			console.log('editId - ', this.editId)
			console.log('document - ', document)
			axios.post(url, document)
				.then(response => {
					this.loading = false
					if (response.data.error !== false) {
						this.message = 'Successfully updated agent'
						this.snackbar = true
						this.snackbarColor = 'error'
						this.approveRejectDialog = false
						this.getInitData(this.currentPage)
						return
					}
					// this.getInitData(this.currentPage)
					this.message = response.data.message
					this.snackbar = true
					this.snackbarColor = 'primary'
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
					this.loading = false
				})
			this.confirmDialog = false
		},
		createAgentPopDialog () {
			this.createAgentDialog = true
		},

		getInitData (page) {
			var url = config.serverURI + '/udr/getAll?page=' + page + '&size=' + this.numberOfItemsPerPage + '&paginate=Y'
			axios.get(url)
				.then(response => {
					this.files = response.data.content
					console.log('----->>>>>>>>>22 ', response.data.content)
					console.log('----->>>>>>>>> ', this.files)
					console.log('----->>>>>>>>>44 ', this.organisationType)
					this.numberOfLinks = response.data.totalPages
					this.numberOfItemsPerPage = response.data.size
					this.currentPage = response.data.number
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
				})
			return this.files
		},

		confirmApproveReject (id, status) {
			this.editId = id
			if (status === 1) {
				this.approveRejectStatus = true
			} else {
				this.approveRejectStatus = false
			}
			this.approveRejectDialog = true
		},
		showGrowers (id) {
			this.growersDialog = true
			this.getGrowersByAgentId(id)
		},
		editGrower (id) {
			this.firstNameValueEdit = ''
			this.secondNameValueEdit = ''
			this.lastNameValueEdit = ''
			this.idNumberValueEdit = ''
			this.phoneValueEdit = ''
			this.emailValueEdit = ''
			this.growersSelectedEdit.length = 0
			// this.growers.length = 0

			this.loadingEdit = true
			this.editAgentDialog = true
			this.getGrowersByAgentId(id)
		},
		getGrowersByAgentId (item) {
			this.filteredList2.length = 0
			// this.growers.length = 0
			console.log('item - ', item)
			// let id = item.id;
			var url = config.serverURI + '/udr/getFarmersByAgentId?id=' + item
			axios.get(url)
				.then(response => {
					// this.files = response.data
					const data = response.data
					// this.filteredList2 = data;
          this.filteredList2 = response.data
					console.log('----->>>>>>>>>0 ', data)
					console.log('----->>>>>>>>>022 ', this.growers)
					// this.editAgentDialog = true

					const id = data[0].agentId.id
					this.firstNameValueEdit = data[0].agentId.fname
					this.secondNameValueEdit = data[0].agentId.sname
					this.lastNameValueEdit = data[0].agentId.lname
					this.idNumberValueEdit = data[0].agentId.idNum
					this.phoneValueEdit = data[0].agentId.phone
					this.emailValueEdit = data[0].agentId.email

					/*data.forEach(x => {
            console.log('xdd - ', x)
						// this.growers.length = 0;
						const id = x.growerId.id
						const code = x.growerId.organisationCode
						const vals = { key: id, value: code }
						console.log('==>1 ', id)
						console.log('==>2 ', code)
						this.growersSelectedEdit.push(vals)
						this.filteredList2.push(x)
            console.log('filteredList2  - ', this.filteredList2)
					})*/

					this.editId = id
					this.originalGrowersData = {
						id: id,
						firstName: this.firstNameValueEdit,
						secondName: this.secondNameValueEdit,
						lastName: this.lastNameValueEdit,
						idNumber: this.idNumberValueEdit,
						email: this.emailValueEdit,
						phone: this.phoneValueEdit,
						growers: this.growersSelectedEdit
					}
					this.loadingEdit = false
				})
				.catch(error => {
					this.loadingEdit = false
					// Request failed.
					console.log('error', error.response)
				})
			return this.files
		}
	}
}

</script>
<style>

h4 {
  font-size: 15px;
}

h5 {
  font-size: 19px;
  font-weight: bold;
}
.catalogue_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.catalogue_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.catalogue_box:after, .catalogue_box:before {
  right: 100%;
  top: 17%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.catalogue_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}

.catalogue_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table tbody tr > td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}

.pagination {
  background-color: red;
}

.paginationtext {
  color: #733D29;
}

.pagination > li > a,
.pagination > li > span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}

.pagination > li.active > .page-link {
  background: #00513B;
  color: #fff;
}

.custom-icon {
  font-size: 18px; /* Adjust the size as needed */
}
.table-responsive {
  overflow-x: auto; /* Enable horizontal scrolling */
}

.table {
  min-width: 600px; /* Minimum width to maintain structure */
}

/* Optional: Adjust the size of text on smaller screens */
@media (max-width: 600px) {
  .table td,
  .table th {
    font-size: 12px; /* Adjust font size */
  }
}

.custom-icon {
  font-size: 18px; /* Adjust the size as needed */
}

.custom-btn {
  background-color: rgb(123, 194, 67) !important; /* Purple */
  color: white !important;
  text-transform: none;
}

</style>
